import SearchResult from './views/SearchResult'

const route = [
  {
    path: '/resultat-recherche',
    name: 'searchresult',
    component: SearchResult,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    },
    props: true
  },
  {
    path: '',
    name: 'collection',
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      collection: true,
      title: 'Collections',
      lang_code: 'collections',
      fn: 'aGetCategory',
      role: ['A','R','C','I'],
      order: 2
    },
    children: []
  }
]

export default route